export enum ArticleContextMenuName {
    ArticleContextMenu = 'article.actionmenu',
    ArticleShareContextMenu = 'article.share.actionmenu',
    ArticlePrintContextMenu = 'article.print.actionmenu',
    ArticleTranslationContextMenu = 'article.translation.actionmenu',
    ArticleTocContextMenu = 'article.toc.actionmenu',
    ArticleSaveToCollectionContextMenu = 'article.saveToCollection.actionmenu',
}
